<template>
  <div class="p-8 bg-[#FAFBFC] min-h-screen">
    <header class="mb-10">
      <h1 class="text-3xl font-extrabold text-[#222222] tracking-tight">Paramètres Système</h1>
      <p class="text-gray-500 font-medium">Configuration globale du moteur Datafuse et des services tiers.</p>
    </header>

    <div class="grid lg:grid-cols-12 gap-8">
      
      <div class="lg:col-span-3 space-y-2">
        <button v-for="tab in tabs" :key="tab.id" 
                @click="activeTab = tab.id"
                :class="activeTab === tab.id ? 'bg-white border-dimotec-orange text-dimotec-orange shadow-sm' : 'bg-transparent border-transparent text-gray-500 hover:bg-gray-100'"
                class="w-full flex items-center gap-3 px-6 py-4 border-l-4 rounded-r-xl font-bold transition-all text-sm">
          <component :is="tab.icon" class="w-5 h-5" />
          {{ tab.label }}
        </button>
      </div>

      <div class="lg:col-span-9 space-y-8">
        
        <div v-if="activeTab === 'general'" class="bg-white rounded-[2.5rem] p-8 shadow-sm border border-gray-100">
          <h2 class="text-xl font-black mb-6">Identité de la Plateforme</h2>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div class="space-y-4">
              <label class="block text-xs font-black uppercase tracking-widest text-gray-400">Nom de l'Instance SaaS</label>
              <input type="text" v-model="settings.siteName" class="w-full bg-gray-50 border-none rounded-xl py-3 px-4 focus:ring-2 focus:ring-dimotec-orange/20 font-medium">
            </div>
            <div class="space-y-4">
              <label class="block text-xs font-black uppercase tracking-widest text-gray-400">URL de Support (Support Link)</label>
              <input type="text" v-model="settings.supportUrl" class="w-full bg-gray-50 border-none rounded-xl py-3 px-4 focus:ring-2 focus:ring-dimotec-orange/20 font-medium">
            </div>
          </div>
          <div class="mt-8">
            <label class="block text-xs font-black uppercase tracking-widest text-gray-400 mb-4">Logo de la Console SuperAdmin</label>
            <div class="flex items-center gap-6 p-6 border-2 border-dashed border-gray-100 rounded-2xl">
              <div class="w-20 h-20 bg-gray-50 rounded-2xl flex items-center justify-center">
                <span class="text-3xl font-black text-gray-200">DF</span>
              </div>
              <button class="px-6 py-2 bg-gray-900 text-white rounded-xl text-xs font-bold uppercase tracking-widest">Remplacer le logo</button>
            </div>
          </div>
        </div>

        <div v-if="activeTab === 'notifications'" class="bg-white rounded-[2.5rem] p-8 shadow-sm border border-gray-100">
          <h2 class="text-xl font-black mb-6">Configuration Mails (SMTP)</h2>
          <div class="space-y-6">
            <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div class="md:col-span-2 space-y-2">
                <label class="text-xs font-bold text-gray-500">Serveur Sortant (Host)</label>
                <input type="text" placeholder="smtp.postmarkapp.com" class="w-full bg-gray-50 border-none rounded-xl py-3 px-4 text-sm">
              </div>
              <div class="space-y-2">
                <label class="text-xs font-bold text-gray-500">Port</label>
                <input type="text" placeholder="587" class="w-full bg-gray-50 border-none rounded-xl py-3 px-4 text-sm">
              </div>
            </div>
            <div class="flex items-center gap-4 p-4 bg-blue-50 text-blue-700 rounded-2xl">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
              <p class="text-xs font-medium">Les mails servent aux alertes "Papier bas" et aux réinitialisations de mot de passe clients.</p>
            </div>
          </div>
        </div>

        <div v-if="activeTab === 'security'" class="bg-white rounded-[2.5rem] p-8 shadow-sm border border-gray-100">
          <h2 class="text-xl font-black mb-6">Sécurité des Données</h2>
          <div class="divide-y divide-gray-50">
            <div class="py-6 flex justify-between items-center">
              <div>
                <p class="text-sm font-bold text-gray-900">Anonymisation des Tickets (RGPD)</p>
                <p class="text-xs text-gray-400">Supprimer les noms clients après 24h.</p>
              </div>
              <div class="w-12 h-6 bg-green-500 rounded-full flex items-center px-1">
                <div class="w-4 h-4 bg-white rounded-full ml-auto"></div>
              </div>
            </div>
            <div class="py-6 flex justify-between items-center">
              <div>
                <p class="text-sm font-bold text-gray-900">Forcer le HTTPS sur les TV</p>
                <p class="text-xs text-gray-400">Refuse la connexion si le certificat n'est pas valide.</p>
              </div>
              <div class="w-12 h-6 bg-gray-200 rounded-full flex items-center px-1">
                <div class="w-4 h-4 bg-white rounded-full"></div>
              </div>
            </div>
          </div>
        </div>

        <div class="flex justify-between items-center bg-gray-900 rounded-[2rem] p-6 shadow-xl">
          <p class="text-white text-xs font-medium italic opacity-60">Modifié il y a 3 minutes par SuperAdmin</p>
          <div class="flex gap-4">
            <button class="px-6 py-3 text-white/50 text-xs font-black uppercase tracking-widest hover:text-white transition">Annuler</button>
            <button class="px-8 py-3 bg-blue-500 text-white rounded-xl font-black text-xs uppercase tracking-widest shadow-lg shadow-blue-900/20 active:scale-95 transition-all">
              Sauvegarder les réglages
            </button>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeTab: 'general',
      tabs: [
        { id: 'general', label: 'Général & Branding', icon: 'SettingsIcon' },
        { id: 'notifications', label: 'Notifications & SMTP', icon: 'BellIcon' },
        { id: 'security', label: 'Sécurité & RGPD', icon: 'ShieldCheckIcon' },
        { id: 'api', label: 'Webhooks & API Keys', icon: 'KeyIcon' },
        { id: 'backup', label: 'Sauvegardes Database', icon: 'DatabaseIcon' }
      ],
      settings: {
        siteName: 'Datafuse Automation Suite',
        supportUrl: 'https://support.datafuse.io'
      }
    }
  }
}
</script>